<template>
    <div>
        <div name="query-sort-block">
            <swb-query-sort-area ref="query_model_ctrl" :configAuto="configAuto" :confKey="confKey" :queryHandler="queryHandler" :popupHandler="popupHandler"></swb-query-sort-area>
        </div>

        <swb-result-table name="result_table" ref="result_table" :confKey="confKey" :configAuto="configAuto" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect" :rowKeyPropName="rowKeyPropName" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :height="tableHeight" :pageNoChangeHandler="pageNoChangeHandler" :rowDblClickHandler="rowDblClickHandler"></swb-result-table>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, DomSizeWatcher, Routes } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'
    import { openFundTransActRecDlg } from './ActRecDlg'
    import { checkUserActionPerm } from '../index'

    import finacApi from '../../api/finac'

    import SwbTradeVoucherList from '../tradeVoucher/TradeVoucherList';

    Routes.add(SwbTradeVoucherList);

    import SwbResultColConf from '../query/ResultColConf.vue';
    import SwbResultTable from '../query/ResultTable.vue';

    Vue.regist(SwbResultColConf);
    Vue.regist(SwbResultTable);

    import SwbQuerySortArea from '../query/QuerySortArea';

    Vue.regist(SwbQuerySortArea);

    export default {
        name: 'swb-fund-trans-rec-yj-list',
        path: '/fund/trans/rec/yj/list',
        avlActions: 'view_rec',
        avlScopes: '',
        authen: false,
        desc: '佣金计费单列表',
        helpArticleCode: 'servicer-fund-trans-rec-yj-list',
        data: function () {
            return {
                confKey: 'swb-fund-trans-rec-yj-list',
                configAuto: true,
                tableHeight: '300',
                needPager: true, //是否需要分页（默认：true）
                multiSelect: false, //是否多选（默认：false）
                multiPageSelect: false, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: "id", //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: false, //是否显示行号（默认：true）
                rowNoFixed: false, //行号列是否固定（默认：false）
                btnColName: 'actions',//操作列名称（如果不设置就不显示操作列）
                //
                btnColTitle: '操作',//操作列标题（默认：'操作'）
                btnColWidth: 120,//操作列宽度（默认：100）
                //
                btnColFixed: true, //操作列是否固定
                //
                pageNumber: 1,
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {},
                },
                // 当前时间
                currentDate: new Date(),
                //
                //隐含的默认排序（最好不是显示列中字段，注意：不要设置el-table 的 default-sort属性）
                sortField: null,
                sortOrder: null,
                // 条件查询
                voucherNo: null,
                tradeNo: null,
                buyerName: null
            }
        },
        created: function () {
            this.pageSize = this.pageSizes.first();
            this.tradeNo = this.$route.query.tradeNo || null;
            if(!Utils.isNoB(this.tradeNo)) {
                this.queryModel.filterItems.tradeNo = this.tradeNo;
            }
            this.toGetFundTransRecList();
        },
        mounted() {
            let self = this;
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            $(this.$el).addClass("overflow-hidden");
            //
            let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
            domSizeWatcher.setBaseEl(thisEl);
            domSizeWatcher.setMainEl(thisEl.find('[name="result_table"]'), function (width, height, theEl) {
                // 根据新主元素的内容大小，调整表格高度
                self.tableHeight = height;
            });
            domSizeWatcher.setVtEls(thisEl.find('[name="query-sort-block"]'));
            domSizeWatcher.start(500);
            //
            this.initResultTable();
        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if(domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            initResultTable() {
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                // let confColList = resultColConfCmp.getMetaColList();
                let resultTable = this.$refs['result_table'];
                //关联[列配置对象]到结果表格（结果表格可以实时利用最新的列配置，同时结果表格列宽也会反向同步到[列配置对象]中去）
                resultTable.setQrySortRef(query_model_ctrl);    // .getResultColConfRef()
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    'tradeNo': function (row, colName, colValue, rowIndex, colConf) {
                        let col = '';
                        if(!row.discarded && !row.confirmState && row.directFlag == 1 && row.payDueTime != null && row.payDueTime.format('yyyy-MM-dd') < self.currentDate.format('yyyy-MM-dd')) {
                            col = '<span>佣金欠费</span>  ';
                        }
                        col = col + '<a name="goToTradeVoucher" class="table-cell-link">' + row.tradeNo + '</a>';
                        return col;
                    },
                    'resultText': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.directFlag == -1 && row.result != 1 && row.amount > 0) {
                            return '<span>待退款</span>';
                        } else {
                            return '<span>' + row.resultText + '</span>';
                        }
                    },
                    'actions': function (row, colName, colValue, rowIndex) {
                        let domHtml = '';
                        if(self.checkActionPerm('view_rec')) {
                            domHtml = domHtml + '<a name="view_rec" class="swb-btn swb-btn-link">查看操作记录</a>';
                        }
                        return domHtml;
                    }
                }, /* 单元格按钮点击处理函数 */{
                    'tradeNo': function (row, colName, colValue, rowIndex, btnName) {
                        self.goToTradeVoucherList(row.tradeNo, row.contractOriginalNo);
                    },
                    'actions': function (row, colName, colValue, rowIndex, btnName) {
                        if(btnName === 'view_rec') {
                            self.viewFundTransActRecs(row.id);
                        }
                    }
                });
            },
            renderTable(rows, pagination) {
                let resultTable = this.$refs.result_table;
                //清除数据（如果已经渲染的数据与新的列不是一回事儿）
                //resultTable.clear();
                //同步使用新的自定义列信息
                //resultTable.initMeta(confColList);
                //设置新数据
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };
                resultTable.render(tableData);
            },
            // 单元格点击事件
            rowDblClickHandler: function (row) {
                if(!this.multiSelect) {
                    console.log("----- 双击数据行 ----");
                    console.log(row);
                }
            },
            popupHandler: function (fieldCode, curValue, curText) {
            },
            // 检查资源具体操作权限（可选的是否为指定的岗位id）
            checkActionPerm: function (action, targetPostId) {
                return checkUserActionPerm(Vue.$getClassInfo(this).path, action, targetPostId);
            },
            //
            queryHandler: function (queryModel) {
                //
                this.queryModel = queryModel;
                this.pageNumber = 1;
                this.toGetFundTransRecList();
            },
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.checkedIniting = true;
                this.pageNumber = val;
                this.toGetFundTransRecList();
            },
            //处理排序事件
            sortListData(sortInfo) {
                this.sortField = sortInfo.prop;
                this.sortOrder = sortInfo.order;
                //
                this.toGetFundTransRecList();
            },
            pageNoChangeHandler: function (pageNumber, pageSize) {
                console.log("分页 => 第【" + pageNumber + "】页，大小：" + pageSize);
                //
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                //
                this.toGetFundTransRecList();
            },
            toGetFundTransRecList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };

                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                let resultState = filterItems.resultState;
                if(resultState == 'paySuccess') {
                    filterItems.directFlag = 1;
                    filterItems.result = 1;
                } else if(resultState == 'initPay') {
                    filterItems.directFlag = 1;
                    filterItems.result = 0;
                } else if(resultState == 'refundSuccess') {
                    filterItems.directFlag = -1;
                    filterItems.result = 1;
                } else if(resultState == 'initRefund') {
                    filterItems.directFlag = -1;
                    filterItems.result = 0;
                }
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;

                //
                let msgBoxDlg = MsgBox.loading();
                finacApi.getFundTransRecYjList(postData, function (result) {
                        msgBoxDlg.close();
                        if(result.type === "info") {
                            let data = result.data;
                            let fundTransRecList = data.rows;
                            for(let i = 0; i < fundTransRecList.length; i++) {
                                let fundTransRec = fundTransRecList[i];
                                //
                                let directFlagInfo = getEnumInfoWith('directFlag', 'value', fundTransRec.directFlag);
                                if(!Utils.isNoB(directFlagInfo)) {
                                    //
                                    let resultState = getEnumInfoWith('resultState', 'value', fundTransRec.result);
                                    //h
                                    if(directFlagInfo.name == "Forward") {
                                        fundTransRec.directFlagText = "支付";
                                        if(!Utils.isNoB(resultState) && resultState.name == 'Success') {
                                            fundTransRec.resultText = '已支付';
                                        } else {
                                            fundTransRec.resultText = '待支付';
                                        }
                                    } else {
                                        fundTransRec.directFlagText = "退款";
                                        if(!Utils.isNoB(resultState) && resultState.name == 'Success') {
                                            fundTransRec.resultText = '已退款';
                                        } else {
                                            fundTransRec.resultText = '待退款';
                                        }
                                    }
                                }
                                //
                                let payStartTime = fundTransRec.payStartTime;
                                if(!Utils.isNoB(payStartTime)) {
                                    fundTransRec.payStartTime = new Date(payStartTime).format("yyyy-MM-dd");
                                }
                                let payDueTime = fundTransRec.payDueTime;
                                if(!Utils.isNoB(payDueTime)) {
                                    fundTransRec.payDueTime = new Date(payDueTime).format("yyyy-MM-dd");
                                }
                                //
                                let tradeTypeInfo = getEnumInfoWith('tradeType', 'value', fundTransRec.tradeType);
                                fundTransRec.tradeTypeText = tradeTypeInfo.text;
                                //
                                let yjFeeChargeMode = getEnumInfoWith('yjFeeChargeMode', 'value', fundTransRec.yjFeeChargeMode);
                                if(!Utils.isNoB(yjFeeChargeMode)) {
                                    fundTransRec.yjFeeChargeModeText = yjFeeChargeMode.text;
                                }
                                //
                                let payWayInfo = getEnumInfoWith('payWay', 'value', fundTransRec.payWay);
                                fundTransRec.payWayText = payWayInfo.text;
                                //
                                fundTransRec.amount = fundTransRec.amount.toFixed(2);
                            }
                            //
                            let pagination = result.data.pagination;
                            self.totalCount = pagination.totalCount;
                            self.renderTable(fundTransRecList, pagination);
                        }
                        else {
                            MsgBox.warning(result.message);
                        }
                    }
                )
                ;
            },
            // 跳转交易单列表
            goToTradeVoucherList: function (tradeNo, contractOriginalNo) {
                let type = null;
                if(Utils.isNoB(contractOriginalNo)) {
                    type = getEnumInfoWith('tradeVoucherType', 'name', 'GeneralVoucher').value;
                } else {
                    type = getEnumInfoWith('tradeVoucherType', 'name', 'ContractVoucher').value;
                }
                this.$router.push({
                    path: SwbTradeVoucherList.path,
                    query: {no: tradeNo, tradeVoucherType: type}
                })
            }
            ,
            // 查看资金往来操作记录
            viewFundTransActRecs: function (id) {
                let postData = {
                    targetRecId: id
                };
                openFundTransActRecDlg(postData);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/payment/FundTransRecYjList.vue